/** @jsx jsx */
import * as React from "react";
import { hot } from "react-hot-loader/root";
import { jsx } from "@emotion/core";
import { TabNames } from "../../../utils/AppConstants";
import styles from "./activeTabNavigationStyle";

export interface INavTabs {
    key: string,
    title: string
}

interface ActiveTabsProps {
  tabName: string;
  widgets: INavTabs[];
  onSelectTab: (activeSubSection: string) => void;
  activeSubSection: string
}

const ActiveTabNavigation: React.SFC<ActiveTabsProps> = props => {

  React.useEffect(() => {
    props.onSelectTab(props.widgets[0].key);
  }, [props.tabName]);

  if (props.widgets) {
    return (
      <nav css={styles.container}>
        <ul css={styles.listItemsContainer}>
          {props.widgets.map((widget: INavTabs) => {
            return (
              <li css={styles.tab(widget.key === props.activeSubSection)} onClick={() => { props.onSelectTab(widget.key) }}>{widget.title}</li>
            );
          })}
        </ul>
      </nav>
    )
  }
}

export default hot(ActiveTabNavigation);